import './fonts'
import './styles.css'

import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initTheme } from './components/app-shell'
import { queryClient } from './lib/query-client'
import { router } from './router'

/*
 * Before the first render, not inside it: index.html has already resolved the
 * stored theme onto <html> synchronously, and this picks the same answer back
 * up (so nothing repaints) and starts following the OS while the preference is
 * "Sistem". Doing it in an effect instead would let one frame of the paper
 * theme through on a machine set to dark.
 */
initTheme()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('#root element not found.')
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
